// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wTGE","title":"styles_title__1u5NI"};